import { createSlice } from "@reduxjs/toolkit"

const adSetsSlice = createSlice({
   name: "adSets",
   initialState: {
      adSets: null,
      getAdSetsLoading: false,
      createAdSetLoading: false,
      error: null
   },
   reducers: {
      getAdSetsLoading: (state) => {
         state.getAdSetsLoading = true
         state.error = null
      },
      getAdSetsSuccess: (state, action) => {
         state.adSets = action.payload
         state.getAdSetsLoading = false
         state.error = null
      },
      getAdSetsFailure: (state, action) => {
         state.getAdSetsLoading = false
         state.error = action.payload
      },
      createAdSetLoading: (state) => {
         state.createAdSetLoading = true
         state.error = null
      },
      createAdSetSuccess: (state, action) => {
         // state.adSets = [...state.adSets, action.payload]
         state.createAdSetLoading = false
         state.error = null
      },
      createAdSetFailure: (state, action) => {
         state.createAdSetLoading = false
         state.error = action.payload
      }
   }
})

export const {
   getAdSetsLoading,
   getAdSetsSuccess,
   getAdSetsFailure,
   createAdSetLoading,
   createAdSetSuccess,
   createAdSetFailure
} = adSetsSlice.actions

export default adSetsSlice.reducer
